import {takeEvery} from 'redux-saga';
import {put, call, select} from 'redux-saga/effects';

const readCookie = (k) => {
  const cookie = global.document && global.document.cookie;
  return cookie && (cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2];
};

export function createMiddleware(global) {
  return (store) => (next) => (action) => {
    const authenticated = readCookie('TESCookieV2') !== undefined;
    const events = global.TES && global.TES.events; // it is imported by the tes-event script
    if (events && action.meta && action.meta.requireAuthentication && !authenticated) {
      events.on('logged-in', () => {
        store.dispatch(action);
      });
      return events.trigger('auth-open', 'sign-in', false);
    }
    return next(action);
  };
}

const currentUserSelector = (state) => state.authenticate.user;
const userIsRole = (user, role) =>
  user.roles && user.roles.includes(role);
const userCanModerate = (user) =>
  userIsRole(user, 'moderator') || userIsRole(user, 'systemadministrator');

const GET_USER = 'app-qa/authentication/GET_USER';
export const getUser = () => ({type: GET_USER});

const GET_USER_SUCCESS = 'app-qa/authentication/GET_USER_SUCCESS';
export const getUserSuccess = (user) => ({type: GET_USER_SUCCESS, user});

export const actions = {
  GET_USER,
  GET_USER_SUCCESS,
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case GET_USER_SUCCESS: {
      const user = {...action.user, canModerate: userCanModerate(action.user)};
      return {...state, user};
    }
    default:
      return state;
  }
}

export function sagas({qaClient, currentUserCookie}) {
  function *getCurrentUser() {
    const currentUserState = yield select(currentUserSelector);
    const userCookie = currentUserCookie || readCookie('TESCookieUser');
    if (userCookie && (!currentUserState || currentUserState.id !== +userCookie)) {
      const user = yield call(() => qaClient.getUser());
      yield put(getUserSuccess(user));
    }
  }

  return {
    *watchGetCurrentUser() { yield* takeEvery(GET_USER, getCurrentUser); },
  };
}
